var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7478 16.4375V21.7172H20.7339V16.8C20.7339 16.1262 20.6196 15.4825 20.2962 14.993C19.9507 14.4699 19.4056 14.1828 18.7068 14.1828C17.5946 14.1828 16.959 14.9678 16.6966 15.6352C16.577 15.9319 16.5603 16.2993 16.5603 16.5797V21.7156H14.5448V15.5594C14.5448 14.5639 14.5192 13.7007 14.488 12.9406H16.1325L16.2248 13.849L16.2705 14.2984H16.7223H16.7827H17.0604L17.2072 14.0627C17.5377 13.5318 18.3668 12.7203 19.7781 12.7203C20.6528 12.7203 21.3746 13.0121 21.8834 13.5825C22.3977 14.159 22.7478 15.0805 22.7478 16.4375ZM15.8835 0.5C7.38367 0.5 0.5 7.44316 0.5 16C0.5 24.5568 7.38367 31.5 15.8835 31.5C24.3834 31.5 31.2671 24.5568 31.2671 16C31.2671 7.44316 24.3834 0.5 15.8835 0.5ZM11.7402 21.7172H9.72625V12.9422H11.7402V21.7172ZM10.7146 10.7422C10.0425 10.7422 9.64718 10.29 9.64718 9.72187C9.64718 9.41957 9.75697 9.17237 9.93416 9.00022C10.1112 8.82826 10.3832 8.70469 10.7534 8.70469C11.1219 8.70469 11.3819 8.82703 11.5508 8.99554C11.7209 9.16531 11.8314 9.41477 11.8394 9.72725C11.8381 10.0212 11.7317 10.2676 11.5556 10.4406C11.3798 10.6134 11.1044 10.7422 10.7146 10.7422Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.64ed1e1a10608073dae976887d81273f.svg";
export { ForwardRef as ReactComponent };